import { redirect } from 'react-router-dom'

const ORDERED_DEFAULT_ONBOARDING_ROUTES = [
  'struggles-sounds',
  'habits',
  'habits-management',
  'sleep-quality',
  'sleep-hours',
  'sleep-hours-management',
  'sleep-goal',
  'bedtime-routine',
  'bedtime-routine-management',
  'improve-sleep',
  'sleep-tracking',
  'wake-up',
  'all-set',
]

// Store the updated routes array
let updatedOnboardingRoutes = [...ORDERED_DEFAULT_ONBOARDING_ROUTES]

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const formData = await request.formData()
  const currentPage = request.url.split('/').pop()?.split('?')[0]

  const answer = formData.get('answer') as string
  // Check if current page bedtime-routine page and answer is "Not sure yet"
  if (currentPage === 'bedtime-routine' && answer === 'Not sure yet') {
    // Skip bedtime-routine-management page
    updatedOnboardingRoutes = updatedOnboardingRoutes.filter(
      (route) => route !== 'bedtime-routine-management',
    )
  } else {
    updatedOnboardingRoutes = [...ORDERED_DEFAULT_ONBOARDING_ROUTES]
  }
  const next = getNext(request.url)

  if (!next) return redirect('/sign-up/company')

  const nextPathname = getNextPathName({ next, url: request.url })

  if (currentPage === 'success') {
    const hash = formData.get('success') as string

    return redirect(`${nextPathname}#${hash}`)
  } else {
    return redirect(nextPathname)
  }
}

function getNext(url: string): string | undefined {
  const pathname = new URL(url).pathname
  const current = pathname.split('/').pop()

  if (!current) return

  const currentIndex = updatedOnboardingRoutes.indexOf(current)
  const next = updatedOnboardingRoutes[currentIndex + 1]

  return next
}

function getNextPathName({ next, url }: { next: string; url: string }): string {
  const currentPathname = new URL(url).pathname
  const paths = currentPathname.split('/')
  const basePathname = paths.slice(0, -1).join('/')
  const nextPathname = basePathname + '/' + next
  return nextPathname
}
